import { InvestorPricingCalculator } from "./InvestorPricingCalculator";
import { InvestorDealReview } from "./InvestorDealReview";
import { DealPricingForm } from "./DealPricingForm";
import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";

export function PricingPage() {
  const [showReview, setShowReview] = useState(false);
  const [reviewData, setReviewData] = useState<any>(null);

  const handleGenerateReview = (data: any) => {
    setReviewData(data);
    setShowReview(true);
  };

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold">Pricing Dashboard</h2>
        <p className="text-muted-foreground">
          View deal terms and manage pricing
        </p>
      </div>

      <Tabs defaultValue="quoting" className="w-full">
        <TabsList className="grid w-full grid-cols-2">
          <TabsTrigger value="quoting">Deal Pricing</TabsTrigger>
          <TabsTrigger value="investor">Investor Calculator</TabsTrigger>
        </TabsList>

        <TabsContent value="quoting" className="mt-6">
          <DealPricingForm />
        </TabsContent>

        <TabsContent value="investor" className="mt-6">
          <InvestorPricingCalculator onGenerateReview={handleGenerateReview} />
        </TabsContent>
      </Tabs>

      <Dialog open={showReview} onOpenChange={setShowReview}>
        <DialogContent className="max-w-3xl max-h-[90vh] overflow-y-auto print:max-w-full print:max-h-full print:overflow-visible">
          <DialogHeader className="print:hidden">
            <DialogTitle>Investor Deal Review</DialogTitle>
          </DialogHeader>
          {reviewData && (
            <InvestorDealReview
              dealTitle={reviewData.dealTitle}
              propertyAddress={reviewData.propertyAddress}
              currentBalance={reviewData.currentBalance}
              monthlyPayment={reviewData.monthlyPayment}
              paymentsRemaining={reviewData.paymentsRemaining}
              balloonAmount={reviewData.balloonAmount}
              balloonDueDate={reviewData.balloonDueDate}
              propertyValue={reviewData.propertyValue}
              investorPrice={reviewData.investorPrice}
              targetYield={reviewData.targetYield}
              itv={reviewData.itv}
            />
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
}
